import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { Box, Paper } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import useWindowSubtractedHeight from '../../hooks/useWindowSubtractedHeight';

const ServiceAccounting = (props) => {
  const { selectedValuesState, disabled, autocompleteOptions } = props;
  const { selectedValues } = selectedValuesState;
  const [reports, setReports] = useState([]);

  const gridHeight = useWindowSubtractedHeight({ otherContentHeight: 600, minHeight: 480 });

  const columns = dataGridPremiumColumns([
    {
      field: 'docNumber',
      headerName: 'Biz. szám',
      type: 'string',
      valueGetter: (_data, row) => row.doc.docNum,
    },
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'itemName',
      headerName: 'Cikknév',
      type: 'string',
    },
    {
      field: 'qty',
      headerName: 'Mennyiség',
      type: 'string',
      filterable: false,
    },
    {
      field: 'quantityUnitCode',
      headerName: 'Me.',
      type: 'string',
      filterable: false,
      sortable: false,
    },
    {
      field: 'type',
      headerName: 'Irány',
      filterable: false,
      sortable: false,
      renderCell: (data) => {
        return data.row.type === 'RECEIPT' ? (
          <Box sx={{ display: 'inline-flex', alignItems: 'center', columnGap: 0.5 }}>
            Bevételezés
            <ArrowDropUpIcon sx={{ color: 'green', fontSize: 30 }} />
          </Box>
        ) : (
          <Box sx={{ display: 'inline-flex', alignItems: 'center', columnGap: 0.5 }}>
            Kiadás
            <ArrowDropDownIcon sx={{ color: 'red', fontSize: 30 }} />
          </Box>
        );
      },
    },
    {
      field: 'createdAt',
      headerName: 'Rögzítve',
      type: 'dateTime',
      filterable: false,
      sortable: true,
      valueGetter: (_data, row) => {
        return new Date(row.createdAt);
      },
      renderCell: (data) => {
        return dayjs(data.row.createdAt).format('YYYY.MM.DD. HH:mm');
      },
    },
    {
      field: 'createdBy',
      headerName: 'Rögzítette',
      type: 'string',
      valueGetter: (_data, row) => {
        return autocompleteOptions.user.find((user) => user.value === row.createdBy)?.label;
      },
    },
    {
      field: 'isBillable',
      headerName: 'Számlázandó',
      type: 'boolean',
    },
    {
      field: 'warranty',
      headerName: 'Garanciális',
      type: 'boolean',
    },
  ]);

  useEffect(() => {
    setReports([...(selectedValues?.issues ?? []), ...(selectedValues?.receipts ?? [])]);
  }, [selectedValues]);

  return (
    <>
      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper elevation={2} sx={{ overflow: 'hidden', boxShadow: 3, borderRadius: 2, width: '100%' }}>
            <DatagridPremiumUi
              datagridIdentifier={DataGridIdentifiers.ServiceAccounting}
              height={gridHeight}
              columns={columns}
              rows={reports}
              headerFilters={false}
              getRowHeight={() => 'auto'}
              getRowId={(row) => `${row.type}_${row.docId}_${row.lineNum}`}
            />
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default ServiceAccounting;
